module.exports = __webpack_public_path__ + "img/ep1-7.837dd05b.jpg";